<template>
  <NxInput
    name="nome"
    type="select"
    label="Quadro:"
    v-model="localValue"
    :option-groups="listOptions"
    placeholder="Selecione o quadro"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectQuadroColunaTransferencia',
  mixins: [useReactiveModelMixin('value')],
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    boardId: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      listOptions: {},
      selected: null
    }
  },
  created () {
    this.onLoadBoards()
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      if (newVal !== this.value) {
        this.$emit('update:value', newVal)
      }
    }
  },
  methods: {
    onLoadBoards () {
      BoardRepository.Board_GetAllActive()
        .then((res) => {
          let activeOptions = this.filterAndReduce(res, (x) => x.tipoBoard === 'AJUIZAMENTO')
          let options = {
            'Quadros': activeOptions
          }
          this.listOptions = options
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de quadros', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    },
    filterAndReduce (res, condition) {
      return res.data.content
        .filter((x) => x.id != null && condition(x))
        .reduce((acc, x) => {
          acc[x.id] = x.nome
          return acc
        }, {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectQuadroColunaTransferencia.vue